import styled from 'styled-components';
import { getColor } from 'core/utils';
import { resetBtn } from 'styled-manila';

export const Wrapper = styled.div`
	align-content: end;
`;

export const Bubble = styled.div`
	display: ${props => props.hidden ? 'none' : 'block'};
	visibility: ${props => props.hidden ? 'hidden' : 'visible'};
	position: absolute;
	z-index: 11;
	top: calc(100% + 10px);
	right: -40px;
	width: 280px;
	background-color: ${getColor('white')};
	box-shadow: 0 0 50px 0 rgba(60, 77, 88, 0.3);
	border-radius: 4px;
	padding: 15px;

	@media (min-width: 480px) {
		width: 310px;
		right: 0;
	}
`;

export const UserBtn = styled.button`
	${resetBtn}
	display: flex;
	align-content: center;
	align-self: center;
	justify-content: center;
	position: relative;
	font-size: 16px;
	line-height: 1.4;
	color: ${getColor('black')};
	transition: 0.2s;
	text-decoration: none;

	&:hover, &:focus {
		color: ${getColor('easternBlue')};
		text-decoration: none;
	}

	&:focus {
		border: 1px dotted ${getColor("primaryBrand")};
		margin: -1px;
	}
`;

export const BtnText = styled.span`
	white-space: nowrap;
	overflow: hidden;
	font-weight: 600;
	margin-left: 4px;
	max-width: 90px;
	text-overflow: ellipsis;
	color: ${getColor("gray")};
`;
